<!-- Promotion Not Active Screen -->
<div class="min-h-screen flex items-center justify-center bg-base-200 p-8">
	<div class="bg-base-100 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
		
		<!-- Crust Logo -->
		<div class="mb-4">
			<crust-logo [color]="'#202620'" [size]="'h-8 w-auto mx-auto'"></crust-logo>
		</div>

		<p>PROMOTION CLOSED</p>
		
		<!-- Loading State -->
		@if (isLoading()) {
			<span class="loading loading-dots loading-xs"></span>
		}

		<!-- Error State -->
		@if (error() && !isLoading()) {
			<div class="flex flex-col items-center gap-4">
				<p class="text-error">{{ error() }}</p>
			</div>
		}
	</div>
</div>
